"use strict";

import Page from "./components/AddEvent.jsx";

export const auth = true;
export const title = "Add Event";
export const Component = Page;
